import Api from './api'

const loadMapEgressos = async () => {
  const resp = await Api.get('/map')
  return resp
}

export default loadMapEgressos
